export default __webpack_public_path__ + "static/media/maksim.8d19d6ac.jpg";